import { Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { Marquee } from "./Marquee";

const ITEMS = [
  { name: "Marie & Thomas", trip: "Voyage de noces · Maldives", quote: "Notre voyage de noces aux Maldives était parfait, jusqu'au moindre détail." },
  { name: "Camille & Antoine", trip: "Lune de miel · Polynésie", quote: "L'équipe a deviné ce dont nous rêvions avant même que nous le formulions. Inoubliable." },
  { name: "Sarah & sa famille", trip: "Voyage en famille · Île Maurice", quote: "Tout était fluide, des transferts privés aux activités des enfants. Rien n'a été laissé au hasard." },
  { name: "Julie & Nicolas", trip: "Voyage en couple · Santorin", quote: "Une escapade pensée comme un récit. La suite face à la caldeira était un rêve éveillé." },
  { name: "Marc D.", trip: "Escapade · Capri", quote: "Un sens du détail rare. Chaque adresse avait été choisie avec une vraie intention." },
];

const Card = ({ name, trip, quote }) => (
  <figure className="w-[300px] md:w-[360px] mx-3 bg-white border border-[#EAE8E3] p-8">
    <div className="flex gap-0.5" aria-label="5 étoiles">
      {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-[#96836B] text-[#96836B]" />)}
    </div>
    <blockquote className="font-serif-display text-xl italic leading-snug mt-4 text-[#1A1B18]">“{quote}”</blockquote>
    <figcaption className="mt-5">
      <p className="text-sm text-[#1A1B18]">{name}</p>
      <p className="text-xs uppercase tracking-[0.2em] text-[#96836B] mt-1">{trip}</p>
    </figcaption>
  </figure>
);

export const TestimonialsMarquee = () => (
  <section id="temoignages" className="py-24 md:py-28 bg-[#FAF9F6] border-t border-[#EAE8E3] overflow-hidden" data-testid="testimonials-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal>
        <p className="label-eyebrow">Ils nous ont confié leurs voyages</p>
        <h2 className="font-serif-display text-4xl md:text-5xl mt-4 max-w-3xl">Des récits, plus que des séjours.</h2>
      </Reveal>
    </div>

    <div className="mt-14" data-testid="testimonials-marquee">
      <Marquee items={ITEMS} renderItem={(t) => <Card {...t} />} />
    </div>
  </section>
);

export default TestimonialsMarquee;
